import React, { useState } from 'react'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as Constants from '../../../../constants'
import { Form, message } from 'antd'
import { newItemInventory } from '../../../../actions/inventory'
import FormVehicleInventory from '../../../containers/FormVehicleInventory'
import './styles.css'

const NewVehicle = (props) => {
    const [filterVehicles, setFilterVehicles] = useState('')
    const [isSaving, setIsSaving] = useState(false)

    const [form] = Form.useForm()

    const handleSubmitNewVehicle = async values => {
        setIsSaving(true)
        const response = await props.newItemInventory(values)
        setIsSaving(false)
        if (response) {
            message.success('El vehículo se guardó exitósamente')
            props.history.push(`/${Constants.MenuAdmin.INVENTORY.HOME}`)
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const handleBack = () => {
        props.history.goBack()
    }

    return (
        <Grid className="newVehicleCont">
            <Row center="xs">
                <Col xs={12}>
                    Nuevo vehículo - Inventario
                </Col>
            </Row>
            <br/>
            <Row center="xs">
                <Col xs={12} sm={10}>
                    <FormVehicleInventory loading={isSaving} onSubmitVehicleInventory={handleSubmitNewVehicle}
                                          isEditing={false} onBack={handleBack}/>
                </Col>
            </Row>
        </Grid>
    )
}

const mapDispatchToPropsActions = dispatch => ({
    newItemInventory: value => dispatch(newItemInventory(value))
})

const mapStateToProps = state => ({})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(NewVehicle))
